import { createSelector } from 'reselect'

import { getCockpitPartnerClassOptions } from '../../lib/getCockpitPartnerClassOptions'

import { selectCockpitOfferingsCatalog } from './selectCockpitOfferingsCatalog'
import { selectCockpitPartnerClassFlags } from './selectCockpitPartnerClassFlags'
import { selectCockpitPartnerData } from './selectCockpitPartnerData'
import { selectCockpitRtm } from './selectCockpitRtm'

export const selectCockpitPartnerClassOptions = createSelector(
  [
    selectCockpitPartnerClassFlags,
    selectCockpitPartnerData,
    selectCockpitOfferingsCatalog,
    selectCockpitRtm,
  ],
  (partnerClassFlags, partnerData, offeringsCatalog, selectedRtm) =>
    getCockpitPartnerClassOptions({
      partnerClassFlags,
      partnerData,
      offeringsCatalog,
      selectedRtm,
    })
)
